import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/page/Layout'
import Home from '@/page/Home'

Vue.use(Router)

// meta中pageId供监控用
export default new Router({
  routes: [
    // {
    //   path: '/halt', // 移动端填物流
    //   name: 'halt',
    //   meta: {
    //     title: '公告',
    //     pageId: 78,
    //     requireLogin: false
    //   },
    //   component: () => import('@/page/halt.vue')
    // },
    // {
    //   path: '*',
    //   redirect: '/halt'
    // }
    {
      path: '/login',
      name: 'login',
      meta: {
        title: '登录',
        pageId: 44
      },
      component: resolve => require(['../page/Login.vue'], resolve)
    },
    {
      path: '/register',
      name: 'register',
      meta: {
        title: '注册',
        pageId: 45
      },
      component: resolve => require(['../page/Register.vue'], resolve)
    },
    {
      path: '/bind',
      name: 'bind',
      meta: {
        title: '绑定',
        pageId: 70
      },
      component: resolve => require(['../page/Bind.vue'], resolve)
    },
    {
      path: '/fill-info',
      name: 'fill-info',
      meta: {
        title: '完善资料',
        pageId: 71
      },
      component: () => import('@/page/FillInfo.vue')
    },
    {
      path: '/reset',
      name: 'reset',
      meta: {
        title: '重置密码',
        pageId: 46
      },
      component: resolve => require(['../page/Reset.vue'], resolve)
    },
    {
      path: '/terms',
      name: 'terms',
      meta: {
        title: '会员服务协议',
        pageId: 47
      },
      component: resolve => require(['../page/help/Terms.vue'], resolve)
    },
    {
      path: '/notice',
      name: 'notice',
      meta: {
        title: '会员规则',
        pageId: 47
      },
      component: resolve => require(['../page/help/notice.vue'], resolve)
    },
    {
      path: '/privacy',
      name: 'privacy',
      meta: {
        title: '隐私权声明',
        pageId: 72
      },
      component: resolve => require(['../page/help/Privacy.vue'], resolve)
    },
    {
      path: '/question',
      name: 'question',
      meta: {
        title: '常见问题',
        pageId: 48
      },
      component: resolve => require(['../page/help/Question.vue'], resolve)
    },
    {
      path: '/howbuy',
      name: 'howbuy',
      meta: {
        title: '如何订购',
        pageId: 49
      },
      component: resolve => require(['../page/help/HowBuy.vue'], resolve)
    },
    {
      path: '/order-delivery',
      name: 'order-delivery',
      meta: {
        title: '订单配送',
        pageId: 50
      },
      component: resolve => require(['../page/help/OrderDelivery.vue'], resolve)
    },
    {
      path: '/order-query',
      name: 'order-query',
      meta: {
        title: '订单查询',
        pageId: 51
      },
      component: resolve => require(['../page/help/OrderQuery.vue'], resolve)
    },
    {
      path: '/sale-after',
      name: 'sale-after',
      meta: {
        title: '售后服务',
        pageId: 52
      },
      component: resolve => require(['../page/help/SaleAfter.vue'], resolve)
    },
    {
      path: '/pay-type',
      name: 'pay-type',
      meta: {
        title: '支付方式',
        pageId: 53
      },
      component: resolve => require(['../page/help/PayType.vue'], resolve)
    },
    // {
    //   path: '/activityKv',
    //   name: 'activityKv',
    //   meta: {
    //     title: '飞利浦会员商城',
    //     pageId: 80
    //   },
    //   component: () => import('@/page/activityKv.vue')
    // },
    {
      path: '*',
      component: resolve => require(['../page/404.vue'], resolve)
    },
    {
      path: '/',
      name: 'Layout',
      // meta: {
      //   requireLogin: true // 配置此条，进入页面前判断是否需要登陆
      // },
      redirect: '/index',
      component: Layout,
      children: [
        {
          path: 'index',
          name: 'index',
          meta: {
            title: '首页',
            pageId: 54
          },
          component: () => import('@/page/Index.vue')
        },
        {
          path: 'decorate',
          name: 'decorate',
          meta: {
            title: '',
            pageId: 79
          },
          component: () => import('@/page/decorate.vue')
        },
        {
          path: 'product-list',
          name: 'product-list',
          meta: {
            title: '商品列表',
            pageId: 55,
            keepAlive: true
          },
          component: () => import('@/page/product/List.vue')
        },
        {
          path: 'product-detail',
          name: 'product-detail',
          meta: {
            title: '商品详情',
            pageId: 56
          },
          component: () => import('@/page/product/Detail.vue')
        },
        // 易班↓
        {
          path: 'activityShop',
          name: 'activityShop',
          meta: {
            title: '飞利浦会员商城',
            pageId: 83
          },
          component: () => import('@/page/activityShop.vue')
        },
        {
          path: 'luckdraw',
          name: 'luckdraw',
          meta: {
            title: '幸运抽奖',
            pageId: 81
          },
          component: () => import('@/page/luckdraw.vue')
        },
        {
          path: 'myLuckdraw',
          name: 'myLuckdraw',
          meta: {
            title: '我的中奖记录',
            pageId: 82,
            requireLogin: true
          },
          component: () => import('@/page/myLuckdraw.vue')
        },
        {
          path: 'product-detail1',
          name: 'product-detail1',
          meta: {
            title: '商品详情',
            pageId: 84
          },
          component: () => import('@/page/product/Detail1.vue')
        },
        // 易班↑
        {
          path: 'cart',
          name: 'cart',
          meta: {
            title: '购物车',
            pageId: 57,
            requireLogin: true
          },
          component: () => import('@/page/Cart.vue')
        },
        {
          path: 'confirm',
          name: 'confirm',
          meta: {
            title: '订单确认',
            pageId: 58,
            requireLogin: true
          },
          component: () => import('@/page/Confirm.vue')
        },
        {
          path: 'pay',
          name: 'pay',
          meta: {
            title: '支付确认',
            pageId: 59,
            requireLogin: true
          },
          component: () => import('@/page/Pay.vue')
        },
        {
          path: 'paySuccess',
          name: 'paySuccess',
          meta: {
            title: '支付成功',
            pageId: 60,
            requireLogin: true
          },
          component: () => import('@/page/PaySuccess.vue')
        },
        {
          path: 'loading',
          name: 'loading',
          meta: {
            title: '订单处理中',
            pageId: 78,
            requireLogin: true
          },
          component: () => import('@/page/Loading.vue')
        }
      ]
    },
    {
      path: '/home',
      name: 'Home',
      redirect: '/index',
      component: Home,
      children: [
        {
          path: '/center',
          name: 'center',
          meta: {
            title: '个人中心',
            pageId: 61,
            requireLogin: true
          },
          component: () => import('@/page/home/Index.vue')
        },
        {
          path: '/info',
          name: 'info',
          meta: {
            title: '个人资料',
            pageId: 62,
            requireLogin: true
          },
          component: () => import('@/page/home/Info.vue')
        },
        {
          path: '/address',
          name: 'address',
          meta: {
            title: '管理收货地址簿',
            pageId: 63,
            requireLogin: true
          },
          component: () => import('@/page/home/Address.vue')
        },
        {
          path: '/add-address',
          name: 'add-address',
          meta: {
            title: '添加收货地址',
            pageId: 64,
            requireLogin: true
          },
          component: () => import('@/page/home/AddAddress.vue')
        },
        {
          path: '/my-favorite',
          name: 'my-favorite',
          meta: {
            title: '我的收藏',
            pageId: 65,
            requireLogin: true
          },
          component: () => import('@/page/home/Favorite.vue')
        },
        {
          path: '/order-list',
          name: 'order-list',
          meta: {
            title: '我的订单',
            pageId: 66,
            requireLogin: true
          },
          component: () => import('@/page/home/OrderList.vue')
        },
        {
          path: '/order-detail',
          name: 'order-detail',
          meta: {
            title: '订单详情',
            pageId: 67,
            requireLogin: true
          },
          component: () => import('@/page/home/OrderDetail.vue')
        },
        {
          path: '/coupon-list',
          name: 'coupon-list',
          meta: {
            title: '我的优惠券',
            pageId: 68,
            requireLogin: true
          },
          component: () => import('@/page/home/Coupon.vue')
        },
        {
          path: '/invoice',
          name: 'invoice',
          meta: {
            title: '申请开票',
            pageId: 69,
            requireLogin: true
          },
          component: () => import('@/page/home/Invoice.vue')
        },
        {
          path: '/modify-password',
          name: 'modify-password',
          meta: {
            title: '修改密码',
            pageId: 73,
            requireLogin: true
          },
          component: () => import('@/page/home/ModifyPassword.vue')
        },
        {
          path: '/exchange', // PC退换货页面
          name: 'exchange',
          meta: {
            title: '退换服务',
            pageId: 74,
            requireLogin: true
          },
          component: () => import('@/page/home/Exchange.vue')
        },
        {
          path: '/withdraw', // 移动端退货页面
          name: 'withdraw',
          meta: {
            title: '退换服务',
            pageId: 75,
            requireLogin: true
          },
          component: () => import('@/page/home/withdraw.vue')
        },
        {
          path: '/exchange-form', // 移动端换货页面
          name: 'exchange-form',
          meta: {
            title: '换货',
            pageId: 76,
            requireLogin: true
          },
          component: () => import('@/page/home/ExchangeForm.vue')
        },
        {
          path: '/exchange-wl', // 移动端填物流
          name: 'exchange-el',
          meta: {
            title: '退换货物流',
            pageId: 77,
            requireLogin: true
          },
          component: () => import('@/page/home/exchangeWL.vue')
        }
      ]
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (from.name == 'product-detail' && to.name == 'product-list') {
      return {}
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js